import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";

import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";

import Validation from "../../../../utils/Validation";

import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

import { updateSurveyTabAction } from "../../../../store/reducers/leadSurveySlice";
import ResetFormAlert from "../../../../components/common/ResetFormAlert";

interface ManagePopupProps {
  open: boolean;
  onHide: () => void;
  title: string;
  surveyId: any;
}

const ManageNewRoom = (props: ManagePopupProps) => {
  const classes = useStyles();

  const { onHide, open, title, surveyId } = props;

  const dispatch = useDispatch();

  const initialState = {
    roomName: "",
  };

  const [formData, setFormData] = useState<any>(initialState);

  const [isActionCalled, setIsActionCalled] = useState(false);

  const [alerModeShow, setAlertModelShow] = useState(false);

  const [isClickReset, setIsClickReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    roomName: formData?.roomName,
  });

  /* ---------------- HIDE MODAL ---------------- */

  const hideHandler = () => {
    onHide();
    resetAllValidator();
  };

  /* ---------------- SUBMIT ---------------- */

  const handleSubmit = (event: any) => {
    event.preventDefault();

    checkValidator();

    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && !isErrorOptional()) {
        dispatch(
          updateSurveyTabAction({
            tab: "tab1",
            surveyId: surveyId,
            data: {
              name: formData?.roomName,
              roomName: formData?.roomName,
              isNew:true,
              items: [
                {
                  item: "Item 1",
                  quantity: 0,
                  ft3: "0",
                  isWeee: false,
                  isLeave: false,
                  isCust: false,
                  isClear: false,
                  isAwk: false,
                  isExp: false,
                  isHVI: false,
                  hviValue:null
                },
              ],
            },
          }),
        );

        hideHandler();
      }

      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  /* ---------------- INPUT CHANGE ---------------- */

  const handleInputChange = (field: string, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      [field]: value,
    }));

    resetValidator(field);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  /* ---------------- RESET ---------------- */

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const handleClear = () => {
    setFormData(initialState);

    dispatch(setNotificationAction({ message: [], severity: "error" }));

    resetAllValidator();

    setIsClickReset(false);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  /* ================================================= */

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"sm"}
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />

            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="reset"
            />

            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />

              <Grid
                container
                spacing={0.5}
                sx={{
                  background: "#E5F4F1",
                  padding: "10px !important",
                  marginTop: "10px !important",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                }}
              >
                <FormField
                  id="roomName"
                  label="Room Name"
                  placeHolder="Enter room name"
                  type="text"
                  md={12}
                  inSingleGridForm
                  isNonMarginTop
                  value={formData?.roomName || ""}
                  onBlur={onBlurAction}
                  onChange={(e: any) =>
                    handleInputChange("roomName", e.target.value)
                  }
                  error={error && error?.roomName}
                  InputProps={{
                    sx: {
                      height: "36px",
                    },
                  }}
                />
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>

      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageNewRoom;
